import APIService from '@/services/APIService.js';

export default {
  getById(id) {
    return APIService.apiCall().get(`/obrigacoesEspeciais/getById/${id}`);
  },
  getAll(includeExpiredRecords) {
    return APIService.apiCall().get(`/obrigacoesEspeciais/getAll/${includeExpiredRecords}`);
  },
  deletar(id) {
    return APIService.apiCall().get(`/obrigacoesEspeciais/excluir/${id}`);
  },
  executar(id) {
    return APIService.apiCall().get(`/obrigacoesEspeciais/executar/${id}`);
  },
  salvar(postData, id) {
    return APIService.apiCall().post(`/obrigacoesEspeciais/salvar/${id}`, JSON.stringify(postData));
  },
  duplicar(id) {
    return APIService.apiCall().get(`/obrigacoesEspeciais/duplicar/${id}`);
  },
  uploadFile(postData) {
    return APIService.apiCall().post('obrigacoesEspeciais/upload', postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  download(id, config = {}) {
    return APIService.apiCall().get(`/obrigacoesEspeciais/baixar/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
